/** Sunday-first day keys used by day×hour heatmap grids (Class Insights, SmartRate Weekly Earnings). */
export const HEATMAP_DAYS = Object.freeze([
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
]);
